import React from 'react';
import styles from './PaymentErrorModal.module.css';

const PaymentErrorModal = ({ errorType, onClose }) => {
  const messages = {
    canceled: 'You canceled the payment.',
    failed: 'Your payment failed. Try another method.',
    unknown: 'Something went wrong. Please try again.',
  };

  return (
    <div className={styles.backdrop}>
      <div className={styles.modal}>
        <h2 className={styles.title}>Payment Error</h2>
        <p className={styles.message}>{messages[errorType] || messages.unknown}</p>
        <button className={styles.button} onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};

export default PaymentErrorModal;
